import * as React from 'react';

import { SimpleTreeView } from '@mui/x-tree-view';
import { Box, Skeleton } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { Company } from '../../types/Company';
import { Interface } from '../../types/Interface';
import { Product } from '../../types/Product';
import { WorkshopProduct } from '../../types/WorkshopProducts';
import { ProductInterface } from "../../types/ProductInterface";
import { WorkshopProductCombination } from '../../types/WorkshopProductCombination';
import { TestCombination, TestComboSupportVal, getTestComboSupport } from '../../types/TestCombinations';
import { WorkshopResultCounters, GetEmptyResultCounters } from '../../types/WorkshopResult';

import { FolderLabel } from '../../subs/FolderLabel';
import { StyledTreeItem } from '../../subs/StyledTreeItem';

const productSelectHandlerMaker = (handler: (nodeHierarchy: string[]) => void) => {
    function onSelectHandler(event: React.SyntheticEvent<Element, Event>, nodeIds: string[] | string): void {
        handler((nodeIds as string).split('\<\>'));
    }

    return onSelectHandler;
}


export const TestingTreeView = ({ companies, ownCompany, interfaces, products, workshopProducts, workshopProductInterfaces,
    filterDisabled, wsProdCombinations, testCombinations, parentLoading, workshopResultCounters, onSelectHandler }:
    {
        companies: Company[], ownCompany: Company, interfaces: Interface[], testCombinations: TestCombination[],
        products: Product[], workshopProducts: WorkshopProduct[], workshopProductInterfaces: Map<number, ProductInterface[]>,
        wsProdCombinations: WorkshopProductCombination[], parentLoading: boolean, filterDisabled: boolean,
        workshopResultCounters: WorkshopResultCounters[],
        onSelectHandler: (nodeIds: string[]) => void
    }) => {
    const [ownworkshopProducts, setOwnworkshopProducts] = React.useState<WorkshopProduct[]>([]);
    const [isLoading, setIsLoading] = React.useState<boolean>(true);
//    const [serverProds, setserverProds] = React.useState<WorkshopProduct[]>([]);
//    const [clientProds, setclientProds] = React.useState<WorkshopProduct[]>([]);
//    const [ownServerProds, setOwnServerProds] = React.useState<WorkshopProduct[]>([]);
    //    const [ownClientProds, setOwnClientProds] = React.useState<WorkshopProduct[]>([]);

    React.useEffect(() => {
        let ownworkshopProductsLoc: WorkshopProduct[] = [];
        let prod: Product;
        workshopProducts.forEach(wp => {
            prod = products.find(p => p.id === wp.productId) as Product;
            if (prod.companyId === ownCompany.id || filterDisabled) {
                ownworkshopProductsLoc.push(wp);
            }
        });
        setOwnworkshopProducts(ownworkshopProductsLoc);
        setIsLoading(false);
    }, [workshopProducts, products, ownCompany]);
  /*  React.useEffect(() => {
        if (workshopProducts.length === 0 || products.length === 0 || ownCompany === undefined) return;
      //  setIsLoading(true);

        let servers: WorkshopProduct[] = [], clients: WorkshopProduct[] = [];
        if (typeof workshopProducts !== 'undefined') {
            servers = workshopProducts.filter((wp) => wp.isServer);
            clients = workshopProducts.filter((wp) => wp.isClient);
        }
        setserverProds(servers);
        setclientProds(clients);

        let companyServers: WorkshopProduct[] = [], companyClients: WorkshopProduct[] = [];
        companyClients = clients?.filter(wp => products?.find(prod => prod.id === wp.productId)?.companyId === ownCompany.id) ?? [];
        companyServers = servers?.filter(wp => products?.find(prod => prod.id === wp.productId)?.companyId === ownCompany.id) ?? [];
        setOwnServerProds(companyServers);
        setOwnClientProds(companyClients);

        setIsLoading(false);
    }, [workshopProducts, ownCompany, products]);*/

   /* return <Box minWidth={'35%'}>
        {!parentLoading && !isLoading ? (
            <SimpleTreeView slots={{ collapseIcon: RemoveIcon, expandIcon: AddIcon }} onItemSelectionToggle={productSelectHandlerMaker(onSelectHandler)}>
                {ownClientProds && serverProds && <TestingTreeBranch viewType={'Client'} testingCounters={clientCounters}
                    companies={companies} products={products} interfaces={interfaces} topProducts={ownClientProds} lowerProducts={serverProds}
                    workshopProductInterfaces={workshopProductInterfaces} />}

                {ownServerProds && clientProds && <TestingTreeBranch viewType={'Server'} testingCounters={serverCounters}
                    companies={companies} products={products} interfaces={interfaces} topProducts={ownServerProds} lowerProducts={clientProds}
                    workshopProductInterfaces={workshopProductInterfaces} />}
            </SimpleTreeView>
        ) : (
            <Skeleton variant="rectangular" width={'90%'} height={118} />
        )}
    </Box>*/
    return <Box minWidth={'35%'}>
        {!parentLoading && !isLoading ? (
            <SimpleTreeView slots={{ collapseIcon: RemoveIcon, expandIcon: AddIcon }} onItemSelectionToggle={productSelectHandlerMaker(onSelectHandler)}>
                {ownworkshopProducts &&
                    ownworkshopProducts?.map(pc =>
                        <TTVCompanyProducts workshopResultCounters={workshopResultCounters}
                            companies={companies} products={products} interfaces={interfaces} wsProdCombinations={wsProdCombinations} testCombinations={testCombinations}
                            workshopProductInterfaces={workshopProductInterfaces} workshopProducts={workshopProducts} workshopProduct={pc} />)}
            </SimpleTreeView>
        ):(
            <Skeleton variant="rectangular" width={'90%'} height={118} />
        )}
    </Box>
}

// top level: users company products
const TTVCompanyProducts = ({ companies, interfaces, testCombinations, products, workshopProducts,
    workshopResultCounters, workshopProductInterfaces, wsProdCombinations, workshopProduct }:
    {
        companies: Company[], interfaces: Interface[], testCombinations: TestCombination[], workshopResultCounters: WorkshopResultCounters[],
        products: Product[], workshopProducts: WorkshopProduct[], workshopProductInterfaces: Map<number, ProductInterface[]>,
        wsProdCombinations: WorkshopProductCombination[], workshopProduct: WorkshopProduct
    }) => {
    const prod = products.find(p => p.id === workshopProduct.productId) as Product;
    const title = `${prod.name.substring(0, 20)} - ${workshopProduct.productVersion?.substring(0, 8) ?? ''}`;
    const itemIdValue = workshopProduct.id?.toString() ?? 'error';
    const wsProdCombinationA: WorkshopProductCombination[] = wsProdCombinations.filter(wspc => wspc.workshopProductId === workshopProduct.id);
    const wsProdCombinationsLoc: WorkshopProductCombination[] = wsProdCombinations.filter(wspc => wspc.workshopProductId !== workshopProduct.id);
    const workshopResultCountersLoc: WorkshopResultCounters[] = workshopResultCounters.filter(wspc => wspc.workshopProductId === workshopProduct.id);
    const workshopResultCounter: WorkshopResultCounters = workshopResultCounters.find(wspc => wspc.workshopProductId === workshopProduct.id
        && wspc.testCombinationId === 0) ?? GetEmptyResultCounters();
    let testCombinationsLoc: TestCombination[] = [];
    let color: "inherit" | "error" | "info" | "success" | "warning" = "inherit";
    if (workshopResultCounter.testsFailed > 0) color = "error";
    else if (workshopResultCounter.testsWarning > 0) color = "warning";
    else if (workshopResultCounter.testsNotCompleted > 0) color = "info";
    else if (workshopResultCounter.testsPassed > 0) color = "success";

    testCombinations.forEach(tcombo => {
        if (wsProdCombinationsLoc.find(wspc => wspc.testCombinationId === tcombo.id)) {
            testCombinationsLoc.push(tcombo);
        }
    });

    return <StyledTreeItem itemId={itemIdValue} label={<FolderLabel labelText={title} labelVariant='small'
        color={color}
        passed={workshopResultCounter.testsPassed} info={workshopResultCounter.testsNotCompleted}
        warnings={workshopResultCounter.testsWarning} errors={workshopResultCounter.testsFailed} />}>
        {testCombinationsLoc && testCombinationsLoc.map(tcombo =>
            <TTVTestCombinations companies={companies} products={products} interfaces={interfaces}
                wsProdCombinations={wsProdCombinationsLoc.filter(wspc => wspc.testCombinationId === tcombo.id)}
                testCombination={tcombo} workshopProduct={workshopProduct} workshopResultCounters={workshopResultCountersLoc}
                workshopProductInterfaces={workshopProductInterfaces} workshopProducts={workshopProducts} itemIdValueIn={itemIdValue}
                wsProdCombination={wsProdCombinationA.find(wspc => wspc.testCombinationId === tcombo.id) as WorkshopProductCombination}
            />
        )}
    </StyledTreeItem>
}

// next level: test combinations for this product
const TTVTestCombinations = ({ companies, interfaces, testCombination, itemIdValueIn, products, workshopProduct,
    workshopResultCounters, workshopProducts, workshopProductInterfaces, wsProdCombination, wsProdCombinations }:
    {
        companies: Company[], interfaces: Interface[], testCombination: TestCombination, itemIdValueIn: string,
        workshopResultCounters: WorkshopResultCounters[],
        products: Product[], workshopProducts: WorkshopProduct[], workshopProductInterfaces: Map<number, ProductInterface[]>,
        wsProdCombinations: WorkshopProductCombination[], wsProdCombination: WorkshopProductCombination, workshopProduct: WorkshopProduct
    }) => {
    const [testSupport, setTestSupport] = React.useState<TestComboSupportVal[]>([]);

    const itemIdValue = `${itemIdValueIn}<>${testCombination.id ?? 'error'}`;
    const workshopProductsLoc = workshopProducts.filter(wp => wsProdCombinations.find(wspc => wspc.workshopProductId === wp.id));

    const workshopResultCountersLoc: WorkshopResultCounters[] = workshopResultCounters.filter(wspc => wspc.testCombinationId === testCombination.id);
    const workshopResultCounter: WorkshopResultCounters = workshopResultCounters.find(wspc => wspc.workshopProductId === workshopProduct.id
        && wspc.testCombinationId === testCombination.id && wspc.isConsumer === false && wspc.isProvider === false) ?? GetEmptyResultCounters();
    let color: "inherit" | "error" | "info" | "success" | "warning" = "inherit";
    if (workshopResultCounter.testsFailed > 0) color = "error";
    else if (workshopResultCounter.testsWarning > 0) color = "warning";
    else if (workshopResultCounter.testsNotCompleted > 0) color = "info";
    else if (workshopResultCounter.testsPassed > 0) color = "success";

    // get the supported interfaces for this test combination
    React.useEffect(() => {
        async function getTestSupport() {
            let testSupportSearch: TestComboSupportVal = { testCombinationId: testCombination.id, testCaseId: 0, interfacePropertyId: 0 }
            const testComboSupportedResponse = await getTestComboSupport(testSupportSearch, new AbortController());
            if (testComboSupportedResponse.failed) {
                setTestSupport([]);
                return;
            }
            setTestSupport(testComboSupportedResponse.result);
        }

        getTestSupport();
    }, [testCombination.id]);

    return <StyledTreeItem itemId={itemIdValue} label={<FolderLabel labelText={testCombination.combinationName ?? 'error'} labelVariant='small'
        color={color}
        passed={workshopResultCounter.testsPassed} info={workshopResultCounter.testsNotCompleted}
        warnings={workshopResultCounter.testsWarning} errors={workshopResultCounter.testsFailed} />}>
        {testSupport.length !== 0 && wsProdCombination && wsProdCombination.isConsumer &&
            <TTVTestCombinationPC companies={companies} products={products} interfaces={interfaces}
            wsProdCombinations={wsProdCombinations.filter(wspc => wspc.isProvider)} testSupport={testSupport}
            testCombination={testCombination} workshopProductInterfaces={workshopProductInterfaces} workshopProduct={workshopProduct}
                workshopProducts={workshopProductsLoc} itemIdValueIn={itemIdValue} treeType={'C'} workshopResultCounters={workshopResultCountersLoc} />}
        {testSupport.length !== 0 && wsProdCombination && wsProdCombination.isProvider &&
            <TTVTestCombinationPC companies={companies} products={products} interfaces={interfaces}
            wsProdCombinations={wsProdCombinations.filter(wspc => wspc.isConsumer)} testSupport={testSupport}
            treeType={'P'} testCombination={testCombination} workshopProductInterfaces={workshopProductInterfaces} workshopProduct={workshopProduct}
            workshopProducts={workshopProductsLoc} itemIdValueIn={itemIdValue} workshopResultCounters={workshopResultCountersLoc}/>}
    </StyledTreeItem>
}

// next level: provider/consumer side of test combination
const TTVTestCombinationPC = ({ companies, interfaces, testCombination, itemIdValueIn, treeType, products, testSupport,
    workshopResultCounters, workshopProduct, workshopProducts, workshopProductInterfaces, wsProdCombinations }:
    {
        companies: Company[], interfaces: Interface[], testCombination: TestCombination, itemIdValueIn: string, treeType: string,
        workshopResultCounters: WorkshopResultCounters[], testSupport: TestComboSupportVal[],
        products: Product[], workshopProducts: WorkshopProduct[], workshopProductInterfaces: Map<number, ProductInterface[]>,
        wsProdCombinations: WorkshopProductCombination[], workshopProduct: WorkshopProduct
    }) => {

    let workshopResultCountersLoc: WorkshopResultCounters[] = [];
    let workshopResultCounter: WorkshopResultCounters = GetEmptyResultCounters();
    if (treeType === "C") {
        workshopResultCountersLoc = workshopResultCounters.filter(wspc => wspc.isConsumer === true);
        workshopResultCounter = workshopResultCounters.find(wspc => wspc.workshopProductId === workshopProduct.id
            && wspc.testCombinationId === testCombination.id && wspc.isConsumer === true && wspc.isProvider === false
            && wspc.interfaceId === 0) ?? GetEmptyResultCounters();
    }
    else {
        workshopResultCountersLoc = workshopResultCounters.filter(wspc => wspc.isProvider === true);
        workshopResultCounter = workshopResultCounters.find(wspc => wspc.workshopProductId === workshopProduct.id
            && wspc.testCombinationId === testCombination.id && wspc.isConsumer === false && wspc.isProvider === true
            && wspc.interfaceId === 0) ?? GetEmptyResultCounters();
    }
    let color: "inherit" | "error" | "info" | "success" | "warning" = "inherit";
    if (workshopResultCounter.testsFailed > 0) color = "error";
    else if (workshopResultCounter.testsWarning > 0) color = "warning";
    else if (workshopResultCounter.testsNotCompleted > 0) color = "info";
    else if (workshopResultCounter.testsPassed > 0) color = "success";

    const itemIdValue = `${itemIdValueIn}<>${treeType}`;
    const title = treeType === 'P' ? `${testCombination.combinationProvider ?? 'error'}` : `${testCombination.combinationConsumer ?? 'error'}`;
    let workshopProductInterface = workshopProductInterfaces.get(workshopProduct.id) as ProductInterface[];

    // filter interfaces to only those involved in this test combination
    workshopProductInterface = workshopProductInterface.filter(wpi => testSupport.find(wspc => wspc.interfaceId === wpi.interfaceId));

    const interfacesLoc = interfaces.filter(iface => workshopProductInterface.find(wpi => wpi.interfaceId === iface.id));
    const workshopProductsLoc = workshopProducts.filter(wp => wsProdCombinations.find(wspc => wspc.workshopProductId === wp.id));

    return <StyledTreeItem itemId={itemIdValue} label={<FolderLabel labelText={title} labelVariant='small'
        color={color}
        passed={workshopResultCounter.testsPassed} info={workshopResultCounter.testsNotCompleted}
        warnings={workshopResultCounter.testsWarning} errors={workshopResultCounter.testsFailed} />}>
        {interfacesLoc && interfacesLoc.map(iface =>
            <TTVInterfaces companies={companies} products={products} iface={iface} wsProdCombinations={wsProdCombinations}
                treeType={treeType} testCombination={testCombination}
                workshopProductInterfaces={workshopProductInterfaces}
                workshopProducts={workshopProductsLoc} itemIdValueIn={itemIdValue} workshopResultCounters={workshopResultCountersLoc}/>
        )}
    </StyledTreeItem>
}

// interface level
const TTVInterfaces = ({ companies, iface, testCombination, itemIdValueIn, treeType, products,
    workshopResultCounters, workshopProducts, workshopProductInterfaces, wsProdCombinations }:
    {
        companies: Company[], iface: Interface, testCombination: TestCombination, itemIdValueIn: string, treeType: string,
        workshopResultCounters: WorkshopResultCounters[],
        products: Product[], workshopProducts: WorkshopProduct[], workshopProductInterfaces: Map<number, ProductInterface[]>,
        wsProdCombinations: WorkshopProductCombination[]
    }) => {

    const itemIdValue = `${itemIdValueIn}<>${iface.id.toString()}`;
    const title = iface.shortName;
    let workshopProductsLoc: WorkshopProduct[] = [];
    const workshopResultCountersLoc: WorkshopResultCounters[] = workshopResultCounters.filter(wspc => wspc.interfaceId === iface.id);
    const workshopResultCounter: WorkshopResultCounters = workshopResultCounters.find(wspc => wspc.interfaceId === iface.id
        && wspc.testCombinationId === testCombination.id && wspc.companyId === 0) ?? GetEmptyResultCounters();
    let color: "inherit" | "error" | "info" | "success" | "warning" = "inherit";
    if (workshopResultCounter.testsFailed > 0) color = "error";
    else if (workshopResultCounter.testsWarning > 0) color = "warning";
    else if (workshopResultCounter.testsNotCompleted > 0) color = "info";
    else if (workshopResultCounter.testsPassed > 0) color = "success";

    workshopProductInterfaces.forEach((pi, id) => {
        if (workshopProducts.find(wp => wp.id === id)) {
            if (pi.find(i => i.interfaceId === iface.id)) {
                workshopProductsLoc.push(workshopProducts.find(wp => wp.id === id) as WorkshopProduct);
            }
        }
    });
    const productsLoc: Product[] = products.filter(prod => workshopProductsLoc.find(wp => wp.productId === prod.id));
    const companiesLoc: Company[] = companies.filter(c => productsLoc.find(prod => prod.companyId === c.id));

    return <StyledTreeItem itemId={itemIdValue} label={<FolderLabel labelText={title} labelVariant='small'
        color={color}
        passed={workshopResultCounter.testsPassed} info={workshopResultCounter.testsNotCompleted}
        warnings={workshopResultCounter.testsWarning} errors={workshopResultCounter.testsFailed} />}>
        {companiesLoc && companiesLoc.map(company =>
            <TTVCompanies company={company} products={productsLoc} iface={iface} wsProdCombinations={wsProdCombinations}
                treeType={treeType} testCombination={testCombination} workshopProductInterfaces={workshopProductInterfaces}
                workshopProducts={workshopProductsLoc} itemIdValueIn={itemIdValue} workshopResultCounters={workshopResultCountersLoc}/>
        )}
    </StyledTreeItem>
}

const TTVCompanies = ({ company, iface, testCombination, itemIdValueIn, treeType, products,
    workshopResultCounters, workshopProducts, workshopProductInterfaces, wsProdCombinations }:
    {
        company: Company, iface: Interface, testCombination: TestCombination, itemIdValueIn: string, treeType: string,
        workshopResultCounters: WorkshopResultCounters[],
        products: Product[], workshopProducts: WorkshopProduct[], workshopProductInterfaces: Map<number, ProductInterface[]>,
        wsProdCombinations: WorkshopProductCombination[]
    }) => {
    const itemIdValue = `${itemIdValueIn}<>${company.id.toString()}`;
    const title = company.name;
    const workshopProductsLoc: WorkshopProduct[] = workshopProducts.filter(wp => products.find(p => wp.productId === p.id && p.companyId === company.id));
    const workshopResultCountersLoc: WorkshopResultCounters[] = workshopResultCounters.filter(wspc => wspc.companyId === company.id);
    const workshopResultCounter: WorkshopResultCounters = workshopResultCounters.find(wspc => wspc.companyId === company.id
        && wspc.testCombinationId === testCombination.id && wspc.consumerWPId === 0 && wspc.providerWPId === 0) ?? GetEmptyResultCounters();
    let color: "inherit" | "error" | "info" | "success" | "warning" = "inherit";
    if (workshopResultCounter.testsFailed > 0) color = "error";
    else if (workshopResultCounter.testsWarning > 0) color = "warning";
    else if (workshopResultCounter.testsNotCompleted > 0) color = "info";
    else if (workshopResultCounter.testsPassed > 0) color = "success";

    return <StyledTreeItem itemId={itemIdValue} label={<FolderLabel labelText={title} labelVariant='small'
        color={color}
        passed={workshopResultCounter.testsPassed} info={workshopResultCounter.testsNotCompleted}
        warnings={workshopResultCounter.testsWarning} errors={workshopResultCounter.testsFailed} />}>
        {workshopProductsLoc && workshopProductsLoc.map(wp =>
            <TTVTestProduct product={products.find(p => p.id === wp.productId) as Product}
                workshopProduct={wp} itemIdValueIn={itemIdValue} workshopResultCounters={workshopResultCountersLoc} />
        )}
    </StyledTreeItem>
}

const TTVTestProduct = ({ itemIdValueIn, product, workshopResultCounters, workshopProduct}:
    {
        itemIdValueIn: string, product: Product, workshopProduct: WorkshopProduct, workshopResultCounters: WorkshopResultCounters[],
    }) => {

    const itemIdValue = `${itemIdValueIn}<>${workshopProduct.id.toString()}`;
    const title = `${product.name} - ${workshopProduct.productVersion ?? ''}`;
    const workshopResultCounter: WorkshopResultCounters = workshopResultCounters.find(wspc => wspc.consumerWPId === workshopProduct.id
        || wspc.providerWPId === workshopProduct.id) ?? GetEmptyResultCounters();
    let color: "inherit" | "error" | "info" | "success" | "warning" = "inherit";
    if (workshopResultCounter.testsFailed > 0) color = "error";
    else if (workshopResultCounter.testsWarning > 0) color = "warning";
    else if (workshopResultCounter.testsNotCompleted > 0) color = "info";
    else if (workshopResultCounter.testsPassed > 0) color = "success";

    return <StyledTreeItem itemId={itemIdValue} label={<FolderLabel labelText={title} labelVariant='small'
        color={color}
        passed={workshopResultCounter.testsPassed} info={workshopResultCounter.testsNotCompleted}
        warnings={workshopResultCounter.testsWarning} errors={workshopResultCounter.testsFailed} />}
    />
}

/*const TestingTreeBranch = ({ viewType, testingCounters, companies, products,
    interfaces, topProducts, lowerProducts, workshopProductInterfaces }:
    {
        viewType: 'Client' | 'Server', 
        testingCounters: Map<number, TestingCountersMap>,
        companies: Company[], interfaces: Interface[], products: Product[],
        topProducts: WorkshopProduct[], lowerProducts: WorkshopProduct[], workshopProductInterfaces: Map<number, ProductInterface[]>
    }) => {

    let topCounters: TestingCounters = testingCounters.get(0)?.get(0) ?? GetEmptyCounters();

    return <StyledTreeItem itemId={viewType} label={<FolderLabel labelText={viewType} labelVariant='large'
        color={topCounters.color} passed={topCounters.testsPassed} info={topCounters.testsNotCompleted}
        warnings={topCounters.testsWarning} errors={topCounters.testsFailed} />}>
        {interfaces?.map(iface =>
            <UpperInterfaceTree nodeid={viewType} testingCounters={testingCounters} companies={companies} products={products} interfaceMode={iface}
                topProducts={topProducts.filter(wp => workshopProductInterfaces.get(wp.id)?.find(wpi => wpi.interfaceId === iface.id)?.supportedByProduct)}
                lowerProducts={lowerProducts.filter(wp => workshopProductInterfaces.get(wp.id)?.find(wpi => wpi.interfaceId === iface.id)?.supportedByProduct)} />)}
    </StyledTreeItem> 
}

const UpperInterfaceTree = ({ nodeid, testingCounters, companies, products,
    interfaceMode, topProducts, lowerProducts }:
    {
        nodeid: string, testingCounters: Map<number, TestingCountersMap>,
        companies: Company[], interfaceMode: Interface, products: Product[],
        topProducts: WorkshopProduct[], lowerProducts: WorkshopProduct[]
    }) => {
    let topCounters: TestingCounters = testingCounters.get(0)?.get(0) ?? GetEmptyCounters();

    return <StyledTreeItem
        itemId={`${nodeid}<>${interfaceMode.id}`}
        label={<FolderLabel labelText={interfaceMode.name} labelVariant='small'
            color={topCounters.color} />}>
        {topProducts?.map(prod =>
            <UpperProductTree nodeid={`${nodeid}<>${interfaceMode.id}`} testingCounters={testingCounters}
                companies={companies} products={products} 
                topProduct={prod} lowerProducts={lowerProducts} />)}
    </StyledTreeItem>
}

const UpperProductTree = ({ nodeid, testingCounters, companies, products,
    topProduct, lowerProducts }:
    {
        nodeid: string,
        testingCounters: Map<number, TestingCountersMap>,
        companies: Company[], products: Product[],
        topProduct: WorkshopProduct, lowerProducts: WorkshopProduct[]
    }) => {
    // use the WorkshopProduct to get the products that involve this tree, and use to filter out the companies list
    const productsLoc = products.filter(prod => lowerProducts.find(wp => wp.productId === prod.id));
    const companiesLoc = companies.filter(company => productsLoc.find(prod => prod.companyId === company.id));
    const topProductLoc = products.find(prod => prod.id === topProduct.productId) as Product;
    let prodCounters: TestingCountersMap = testingCounters.get(topProduct.id) ?? new Map<number, TestingCounters>();

    return <StyledTreeItem
        itemId={`${nodeid}<>${topProduct.productId} ${topProduct.id}`}
        label={<FolderLabel labelText={topProductLoc.name + ' ' + topProduct.productVersion} labelVariant='small'
            color={prodCounters.get(0)?.color} passed={prodCounters.get(0)?.testsPassed}
            info={prodCounters.get(0)?.testsNotCompleted}
            warnings={prodCounters.get(0)?.testsWarning} errors={prodCounters.get(0)?.testsFailed} />}>
        {companiesLoc?.map(company =>
            <LowerCompanyTree nodeid={`${nodeid}<>${topProduct.productId} ${topProduct.id}`}
                pairedCounters={prodCounters}
                lowerProducts={lowerProducts.filter(wp => products.find(prod => prod.id === wp.productId)?.companyId === company.id)}
                topProduct={topProduct} company={company} products={products} />)}
    </StyledTreeItem>
}

const LowerCompanyTree = ({ nodeid, pairedCounters, company, products,
    topProduct, lowerProducts }:
    {
        nodeid: string,
        pairedCounters: TestingCountersMap,
        company: Company, products: Product[],
        topProduct: WorkshopProduct, 
        lowerProducts: WorkshopProduct[]
    }) => {

    let companyCounters: TestingCounters = GetEmptyCounters();
    lowerProducts.forEach(prod => AddCounters(companyCounters, pairedCounters.get(prod.id) ?? GetEmptyCounters()));

    return <StyledTreeItem
        itemId={`${nodeid}<>${company.id}`}
        label={<FolderLabel labelText={company.name} labelVariant='small' color={companyCounters.color} />}>
        {lowerProducts?.map(prod => topProduct.id !== prod.id &&
            <LowerProdTree nodeid={`${nodeid}<>${company.id}`}
                pairedCounter={pairedCounters.get(prod.id) ?? GetEmptyCounters()}
                product={products.find(p => p.id === prod.productId) as Product}
                lowerProduct={prod} />)}
    </StyledTreeItem>
}

const LowerProdTree = ({ nodeid, pairedCounter, product, lowerProduct }:
    {
        nodeid: string,
        pairedCounter: TestingCounters,
        product: Product,
        lowerProduct: WorkshopProduct
    }) => {
    return <StyledTreeItem
        itemId={`${nodeid}<>${lowerProduct.productId} ${lowerProduct.id}`}
        label={<FolderLabel labelText={product.name + ' ' + lowerProduct.productVersion} labelVariant='small'
            color={pairedCounter.color} passed={pairedCounter.testsPassed}
            info={pairedCounter.testsNotCompleted}
            warnings={pairedCounter.testsWarning} errors={pairedCounter.testsFailed} />}>
    </StyledTreeItem>
}*/

